<template>
  <div v-if="reset" class="reset">
    <div class="basis-info">
      <span class="basis-info-title">
        <img class="reset-editor-icon person" src="/img/icons/ico_info_g.png" alt="Info">
        &nbsp;
        {{ $t('reset.editor.basis_info') }}
      </span>
      <div class="basis-info-row">
        <div class="dot" />
        <div class="basis-info-name">
          {{ $t('column.nm.title') }} : {{ reset.nm }}
        </div>
      </div>
      <div class="basis-info-row basis-info-row-story">
        <div class="dot" />
        <div class="basis-info-name">
          {{ $t('reset.text.reset_story') }}
        </div>
      </div>
      <div class="reset-story-container">
        <div class="reset-story-box" v-html="reset.story ? escapeHtmlWithNewLine(reset.story) : '-'" />
      </div>
      <div class="basis-info-row">
        <div class="basis-info-overview">
          <div class="dot" />
          <div class="basis-info-overview-content">
            {{ $t('column.nm.nm') }} : {{ reset.userNm }}
          </div>
        </div>
        <div class="basis-info-overview">
          <div class="dot" />
          <div class="basis-info-overview-content">
            {{ $t('column.nm.age_code') }} : {{ $t('code.nm.' + reset.ageCode) }}
          </div>
        </div>
        <div class="basis-info-overview">
          <div class="dot" />
          <div class="basis-info-overview-content">
            {{ $t('column.nm.sexdstn_code') }} : {{ $t('code.nm.' + reset.sexdstnCode) }}
          </div>
        </div>
      </div>
      <div v-if="reset.bgnde && reset.endde" class="basis-info-row">
        <div class="dot" />
        <div class="basis-info-name">
          {{ $t('column.nm.de') }} :
          {{ reset.bgnde.replaceAll('/', '.') }} ~ {{ reset.endde.replaceAll('/', '.') }}
          (총 {{ getTotalDateCount(reset) }}일)
        </div>
      </div>

      <div class="basis-info-2-container">
        <div class="basis-info-row">
          <div class="basis-info-label-container">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('column.nm.bdwgh') }}
            </div>
            <div class="basis-info-diff">
              {{ isNaN(reset.resultBdwgh - reset.bgnBdwgh) ? 0 : Math.round(reset.resultBdwgh - reset.bgnBdwgh) }}
              &nbsp;
              <i v-if="reset.resultBdwgh - reset.bgnBdwgh < 0" class="fa fa-caret-down" aria-hidden="true" />
              <i v-else-if="reset.resultBdwgh - reset.bgnBdwgh > 0" class="fa fa-caret-up" aria-hidden="true" />
              <i v-else class="fa fa-minus" aria-hidden="true" />
            </div>
          </div>
          <div class="basis-info-begin">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
              {{ reset.bgnBdwgh }}
            </div>
          </div>
          <div class="basis-info-result">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.result') }}</label>
              {{ reset.resultBdwgh }}
            </div>
          </div>
          <div class="basis-info-goal">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.goal') }}</label>
              {{ reset.goalBdwgh }}
            </div>
          </div>
        </div>
        <div class="basis-info-row">
          <div class="basis-info-label-container">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('column.nm.bone_rate') }}
            </div>
            <div class="basis-info-diff">
              {{ isNaN(reset.resultBoneRate - reset.bgnBoneRate) ? 0 : Math.round(reset.resultBoneRate - reset.bgnBoneRate) }}
              &nbsp;
              <i v-if="reset.resultBoneRate - reset.bgnBoneRate < 0" class="fa fa-caret-down" aria-hidden="true" />
              <i v-else-if="reset.resultBoneRate - reset.bgnBoneRate > 0" class="fa fa-caret-up" aria-hidden="true" />
              <i v-else class="fa fa-minus" aria-hidden="true" />
            </div>
          </div>
          <div class="basis-info-begin">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
              {{ reset.bgnBoneRate }}
            </div>
          </div>
          <div class="basis-info-result">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.result') }}</label>
              {{ reset.resultBoneRate }}
            </div>
          </div>
          <div class="basis-info-goal">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.goal') }}</label>
              {{ reset.goalBoneRate }}
            </div>
          </div>
        </div>
        <div class="basis-info-row">
          <div class="basis-info-label-container">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('column.nm.body_fat') }}
            </div>
            <div class="basis-info-diff">
              {{ isNaN(reset.resultBodyFat - reset.bgnBodyFat) ? 0 : Math.round(reset.resultBodyFat - reset.bgnBodyFat) }}
              &nbsp;
              <i v-if="reset.resultBodyFat - reset.bgnBodyFat < 0" class="fa fa-caret-down" aria-hidden="true" />
              <i v-else-if="reset.resultBodyFat - reset.bgnBodyFat > 0" class="fa fa-caret-up" aria-hidden="true" />
              <i v-else class="fa fa-minus" aria-hidden="true" />
            </div>
          </div>
          <div class="basis-info-begin">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
              {{ reset.bgnBodyFat }}
            </div>
          </div>
          <div class="basis-info-result">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.result') }}</label>
              {{ reset.resultBodyFat }}
            </div>
          </div>
          <div class="basis-info-goal">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.goal') }}</label>
              {{ reset.goalBodyFat }}
            </div>
          </div>
        </div>
        <div class="basis-info-row">
          <div class="basis-info-label-container">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('column.nm.bmi') }}
            </div>
            <div class="basis-info-diff">
              {{ isNaN(reset.resultBmi - reset.bgnBmi) ? 0 : Math.round(reset.resultBmi - reset.bgnBmi) }}
              &nbsp;
              <i v-if="reset.resultBmi - reset.bgnBmi < 0" class="fa fa-caret-down" aria-hidden="true" />
              <i v-else-if="reset.resultBmi - reset.bgnBmi > 0" class="fa fa-caret-up" aria-hidden="true" />
              <i v-else class="fa fa-minus" aria-hidden="true" />
            </div>
          </div>
          <div class="basis-info-begin">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
              {{ reset.bgnBmi }}
            </div>
          </div>
          <div class="basis-info-result">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.result') }}</label>
              {{ reset.resultBmi }}
            </div>
          </div>
          <div class="basis-info-goal">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.goal') }}</label>
              {{ reset.goalBmi }}
            </div>
          </div>
        </div>
        <div class="basis-info-row">
          <div class="basis-info-label-container">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('column.nm.body_fat_rate') }}
            </div>
            <div class="basis-info-diff">
              {{ isNaN(reset.resultBodyFatRate - reset.bgnBodyFatRate) ? 0 : Math.round(reset.resultBodyFatRate - reset.bgnBodyFatRate) }}
              &nbsp;
              <i v-if="reset.resultBodyFatRate - reset.bgnBodyFatRate < 0" class="fa fa-caret-down" aria-hidden="true" />
              <i v-else-if="reset.resultBodyFatRate - reset.bgnBodyFatRate > 0" class="fa fa-caret-up" aria-hidden="true" />
              <i v-else class="fa fa-minus" aria-hidden="true" />
            </div>
          </div>
          <div class="basis-info-begin">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
              {{ reset.bgnBodyFatRate }}
            </div>
          </div>
          <div class="basis-info-result">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.result') }}</label>
              {{ reset.resultBodyFatRate }}
            </div>
          </div>
          <div class="basis-info-goal">
            <div class="begin-number basis-info-number simple-design">
              <label class="basis-info-number-label">{{ $t('reset.editor.goal') }}</label>
              {{ reset.goalBodyFatRate }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="(reset.beginFrontImages && reset.beginFrontImages.length > 0) || (reset.beginSideImages && reset.beginSideImages.length > 0)" class="begin-image-row">
        <div class="begin-image-title">
          <div class="dot" />
          <div class="basis-info-label">
            {{ $t('reset.editor.begin_photo') }}
          </div>
        </div>
        <div class="basis-info-controls basis-info-images-controls">
          <div class="basis-info-control basis-info-image">
            <div class="image-container">
              <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(reset.beginFrontImages)" :alt="$t('reset.editor.front_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefBeginFrontImages', $event)" />
              <image-viewer v-if="reset && reset.beginFrontImages" ref="imageViewerRefBeginFrontImages" :src="getImgUrl(reset.beginFrontImages, 1600)" :alt="$t('reset.editor.front_image')" />
            </div>
            <div class="basis-info-control-name-and-button">
              <div class="basis-info-control-name">
                {{ $t('reset.editor.front_image') }}
              </div>
            </div>
          </div>
          <div class="basis-info-control basis-info-image">
            <div class="image-container">
              <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(reset.beginSideImages)" :alt="$t('reset.editor.side_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefBeginSideImages', $event)" />
              <image-viewer v-if="reset && reset.beginSideImages" ref="imageViewerRefBeginSideImages" :src="getImgUrl(reset.beginSideImages, 1600)" :alt="$t('reset.editor.side_image')" />
            </div>
            <div class="basis-info-control-name-and-button">
              <div class="basis-info-control-name">
                {{ $t('reset.editor.side_image') }}
              </div>
            </div>
          </div>
          <div class="clear" />
        </div>
      </div>
      <div v-if="hasAnyImages(reset.hists) && (!shared || showOnlyFriends)" class="intake-certificate-image-row">
        <div class="intake-certificate-image-title">
          <div class="dot" />
          <div class="basis-info-label">
            {{ $t('reset.editor.intake_certificate') }}
          </div>
        </div>
        <div class="basis-info-controls basis-info-images-controls">
          <div v-for="(hist, histIndex) in getHistByTimeFromHist()" :key="'hist-by-time-' + histIndex" class="basis-info-control basis-info-image hist-info-image">
            <div class="image-container">
              <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(hist.images)" :alt="$t('reset.text.' + hist.time)" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRef' + hist.images[0].id, $event)" />
              <image-viewer v-if="hist && hist.images" :ref="'imageViewerRef' + hist.images[0].id" :src="getImgUrl(hist.images, 1600)" :alt="$t('reset.text.' + hist.time)" />
            </div>
            <div class="basis-info-control-name-and-button">
              <div class="basis-info-control-name">
                {{ hist.de.replaceAll('/', '.').substring(hist.de.indexOf('/') + 1) }} {{ $t('reset.text.' + hist.time) }}
              </div>
            </div>
            <div class="clear" />
          </div>
          <div class="clear" />
        </div>
      </div>

      <div v-if="(reset.resultFrontImages && reset.resultFrontImages.length > 0) || (reset.resultSideImages && reset.resultSideImages.length > 0)" class="result-image-row">
        <div class="result-image-title">
          <div class="dot" />
          <div class="basis-info-label">
            {{ $t('reset.editor.result_photo') }}
          </div>
        </div>
        <div class="basis-info-controls basis-info-images-controls">
          <div class="basis-info-control basis-info-image">
            <div class="image-container">
              <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(reset.resultFrontImages)" alt="$t('reset.editor.front_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefResultFrontImages', $event)" />
              <image-viewer v-if="reset && reset.resultFrontImages" ref="imageViewerRefResultFrontImages" :src="getImgUrl(reset.resultFrontImages, 1600)" :alt="$t('reset.editor.front_image')" />
            </div>
            <div class="basis-info-control-name-and-button">
              <div class="basis-info-control-name">
                {{ $t('reset.editor.front_image') }}
              </div>
            </div>
          </div>
          <div class="basis-info-control basis-info-image">
            <div class="image-container">
              <centered-image :cover="true" :src="getImgUrlWithoutDefaultImgUrl(reset.resultSideImages)" alt="$t('reset.editor.side_image')" default-image-url="/img/unistars/top_logo_white.png" @click="showPreimageViewer('imageViewerRefResultSideImages', $event)" />
              <image-viewer v-if="reset && reset.resultSideImages" ref="imageViewerRefResultSideImages" :src="getImgUrl(reset.resultSideImages, 1600)" :alt="$t('reset.editor.side_image')" />
            </div>
            <div class="basis-info-control-name-and-button">
              <div class="basis-info-control-name">
                {{ $t('reset.editor.side_image') }}
              </div>
            </div>
          </div>
          <div class="clear" />
        </div>
      </div>
      <div class="basis-info-row hidden">
        <div class="dot" />
        <div class="basis-info-label">
          {{ $t('common.text.intake_amount') }}
        </div>
      </div>
      <div class="basis-info-row no-flex hidden">
        <div class="date-selector-detail">
          <calendar
            v-model="reset.period"
            mode="viewer"
            :show-only-selected-period="true"
            :show-week-days="false"
            :init-year-month-by-period="true"
            :day-selectable="true"
            @day-selected="onDaySelected"
          />
        </div>
        <div v-if="selectedSchedule" class="schedule-detail-setting">
          <div class="schedule-time-tabs">
            <div :class="{'morning': true, 'active': scheduleTimeTab === 'morning'}" @click="setScheduleTimeTab('morning', $event)">
              <img src="/img/reset/ic_morning.png" :alt="$t('reset.text.morning')" class="time-icon">
              {{ $t('reset.text.morning') }}
            </div>
            <div :class="{'noon': true, 'active': scheduleTimeTab === 'noon'}" @click="setScheduleTimeTab('noon', $event)">
              <img src="/img/reset/ic_noon.png" :alt="$t('reset.text.noon')" class="time-icon">
              {{ $t('reset.text.noon') }}
            </div>
            <div :class="{'night': true, 'active': scheduleTimeTab === 'night'}" @click="setScheduleTimeTab('night', $event)">
              <img src="/img/reset/ic_night.png" :alt="$t('reset.text.night')" class="time-icon">
              {{ $t('reset.text.night') }}
            </div>
          </div>
          <div v-if="selectedSchedule[scheduleTimeTab] && selectedSchedule[scheduleTimeTab].length > 0" class="schedule-intake-container">
            <div v-for="(resetPrductSched, resetPrductSchedIndex) in selectedSchedule[scheduleTimeTab]" :key="'schedule-' + scheduleTimeTab + '-' + resetPrductSchedIndex">
              <div class="product">
                <div class="dot" />
                <div class="product-image">
                  <img :src="getImgUrl(resetPrductSched.product.image)" :alt="resetPrductSched.product.nm">
                </div>
                <div class="product-title">
                  {{ resetPrductSched.product.nm }}
                </div>
                <div class="product-intake-co">
                  {{ resetPrductSched.intakeCo }}
                  <div class="product-intake-co-unit">
                    {{ resetPrductSched.product.unit }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-intake-data">
            {{ $t('common.text.no_intake') }}
          </div>
        </div>
      </div>
    </div>

    <product-groups :products="reset.products" :show-selected="true" :shared="true" />
    <div class="controls bottom-fixed-controls">
      <div v-if="shared" class="button-area">
        <button v-if="reset.likedFlag === 'Y'" class="btn no-border btn-like" @click="like(false, $event)">
          <i class="fa fa-heart" />
          {{ reset.likeCo ? reset.likeCo : 0 }}
        </button>
        <button v-else class="btn no-border btn-like" @click="like(true, $event)">
          <i class="fa fa-heart-o" />
          {{ reset.likeCo ? reset.likeCo : 0 }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn no-border" @click="toList($event)">
          {{ $t('common.button.list') }}
        </button>
      </div>
      <div v-if="!shared && !showOnlyFriends" class="button-area">
        <button v-if="reset.shareFlag === 'Y'" class="btn no-border" @click="shareCancelConfirm($event)">
          {{ $t('common.button.cancel_share') }}
        </button>
        <button v-else class="btn no-border" @click="shareConfirm($event)">
          {{ $t('common.button.share') }}
        </button>
      </div>
    </div>
    <b-modal
      id="share-cancel-confirm-modal"
      ref="shareCancelConfirmModalRef"
      modal-class="simple-design share-modal"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.close')"
      :lazy="false"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="shareReset($event, 'N')"
    >
      <p class="my-4" v-html="$t('common.notification.cancel_share')" />
    </b-modal>
    <b-modal
      id="share-confirm-modal"
      ref="shareConfirmModalRef"
      modal-class="simple-design share-modal"
      :title="$t('reset.modal.reset_review_registration')"
      :ok-title="$t('common.button.share')"
      :ok-only="true"
      :ok-disabled="shareFlag === 'N'"
      :lazy="false"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="shareReset($event, 'Y')"
    >
      <input-control
        v-model="reset.story"
        name="story"
        type="textarea"
        :no-title="true"
        :placeholder="$t('reset.story.placeholder')"
      />
      <input-control
        v-model="shareFlag"
        name="share_flag"
        type="checkbox"
        class="agree-checkbox"
        :is-switch="false"
        :title="$t('reset.text.consent_to_offer')"
      />
      <a class="show-agreement-button" @click="showAgreement = !showAgreement">
        <span v-if="!showAgreement"><i class="fa-chevron-down fa" /></span>
        <span v-else><i class="fa-chevron-up fa" /></span>
      </a>
      <div class="clear" />
      <p v-if="showAgreement" class="mb-3 stipulation-contents" v-html="stipulation.cn" />
    </b-modal>
  </div>
</template>

<script>
import ProductGroups from './ProductGroups'
export default {
  components: { ProductGroups },
  props: {
    id: {
      type: { Number, String },
      default: undefined
    },
    shared: {
      type: Boolean,
      default: false
    },
    showOnlyFriends: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAgreement: false,
      reset: undefined,
      stipulation: {},
      shareFlag: 'Y',
      scheduleTimeTab: 'morning',
      selectedSchedule: {}
    }
  },
  async mounted() {
    let id = this.id
    if (!id) {
      id = this.$route.query.savedId
    }
    const res = await this.$axios.$get('/reset/reset?id=' + id, {
      no_loading: true
    })
    this.reset = res.data
    if (this.reset.bgnde && this.reset.endde) {
      this.reset.period = [
        {
          bgnde: this.reset.bgnde,
          endde: this.reset.endde
        }
      ]
    }
    const response = await this.$axios.$get(
      '/stipulation/public/stipulation?stplatTyCode=stipulation_type.reset&stplatPrposCode=stipulation_purpose.share'
    )
    if (response.data && response.data.length > 0) {
      this.stipulation = response.data[0]
    }
  },
  methods: {
    showPreimageViewer: function(ref, e) {
      this.vibrate(e)
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      console.log(ref)
      console.log(this.$refs)
      console.log(this.$refs[ref])
      if (
        this.$refs &&
        this.$refs[ref] &&
        this.$refs[ref].length > 0 &&
        this.$refs[ref][0]
      ) {
        this.$refs[ref][0].showImageViewer()
      }
    },
    getHistByTimeFromHist() {
      const hists = []
      if (this.reset && this.reset.hists) {
        for (let i = 0; i < this.reset.hists.length; i++) {
          if (
            this.reset.hists[i].morningFrontImages &&
            this.reset.hists[i].morningFrontImages.length > 0
          ) {
            const hist = {
              de: this.reset.hists[i].de,
              images: this.reset.hists[i].morningFrontImages,
              time: 'morning'
            }
            hists.push(hist)
          }
          if (
            this.reset.hists[i].noonFrontImages &&
            this.reset.hists[i].noonFrontImages.length > 0
          ) {
            const hist = {
              de: this.reset.hists[i].de,
              images: this.reset.hists[i].noonFrontImages,
              time: 'noon'
            }
            hists.push(hist)
          }
          if (
            this.reset.hists[i].nightFrontImages &&
            this.reset.hists[i].nightFrontImages.length > 0
          ) {
            const hist = {
              de: this.reset.hists[i].de,
              images: this.reset.hists[i].nightFrontImages,
              time: 'night'
            }
            hists.push(hist)
          }
        }
      }
      return hists
    },
    toList(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      const query = window.copyObject(this.$route.query)
      delete query.savedId
      this.$router.push({
        query: query
      })
    },
    shareCancelConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('shareCancelConfirmModalRef')
    },
    shareConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (this.isCouponUser()) {
        this.$toast.info(this.$t('reset.text.coupon_user_cannot_share'))
        return
      }
      this.showAgreement = false
      this.showModal('shareConfirmModalRef')
    },
    shareReset(e, shareFlag) {
      this.reset.shareFlag = shareFlag
      if (shareFlag === 'Y') {
        this.reset.stplatId = this.stipulation.id
      } else {
        delete this.reset.stplatId
      }
      this.saveReset(e)
    },
    like(liked, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!this.reset.likeCo) {
        this.reset.likeCo = 0
      }
      this.$axios
        .$get(
          '/reset/like?likeFlag=' + (liked ? 'Y' : 'N') + '&id=' + this.reset.id
        )
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message))
            if (liked) {
              this.reset.likedFlag = 'Y'
              this.reset.likeCo++
            } else {
              this.reset.likedFlag = 'N'
              this.reset.likeCo--
            }
            this.$forceUpdate()
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
    },
    hasAnyImages(hists) {
      if (hists && hists.length > 0) {
        for (let i = 0; i < hists.length; i++) {
          const hist = hists[i]
          if (
            (hist.morningFrontImages && hist.morningFrontImages.length > 0) ||
            (hist.morningSideImages && hist.morningSideImages.length > 0)
          ) {
            return true
          }
          if (
            (hist.noonFrontImages && hist.noonFrontImages.length > 0) ||
            (hist.noonSideImages && hist.noonSideImages.length > 0)
          ) {
            return true
          }
          if (
            (hist.nightFrontImages && hist.nightFrontImages.length > 0) ||
            (hist.nightSideImages && hist.nightSideImages.length > 0)
          ) {
            return true
          }
        }
      }
      return false
    },
    saveReset(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.$axios.$post('/reset/save', this.reset).then(response => {
        if (response.resultCode === 'success') {
          this.hideModal('saveConfirmModalRef')
          this.hideModal('shareConfirmModalRef')
          this.hideModal('shareCancelConfirmModalRef')
          this.$toast.info(this.$t(response.message))
          this.$emit('reset-updated', this.reset)
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    },
    setScheduleTimeTab(tab, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (this.scheduleTimeTab === tab) {
        return
      }
      this.vibrate(e)
      this.scheduleTimeTab = tab
      this.$forceUpdate()
    },
    onDaySelected(param) {
      this.selectedSchedule = undefined
      if (!this.reset.schedules || this.reset.schedules.length === 0) {
        return
      }
      if (!param.day) {
        return
      }

      const de = new Date(param.year, param.month, param.day)
      const deStr = this.$moment(de).format(this.$t('common.format.date'))
      for (let i = 0; i < this.reset.schedules.length; i++) {
        const schedule = this.reset.schedules[i]
        if (schedule.de === deStr) {
          this.selectedSchedule = schedule
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.reset {
  margin-top: 0.8rem;
  margin-bottom: 3rem;
}
.reset-editor-icon {
  width: 0.9166rem;
}
.basis-info-title {
  padding-left: 1rem;
  color: #747474;
  font-size: 0.791666666666667rem !important;
  height: 3.275rem;
  display: flex;
  align-items: center;
  background: rgba(244, 244, 244, 0.4);
}
.basis-info-row {
  display: flex;
  align-items: center;
  clear: both;
  font-size: 0.95rem;
  min-height: 3.275rem;
  padding: 0.6rem 1rem;
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
}
.basis-info-row.basis-info-row-story {
  border-bottom: none;
  padding-bottom: 0;
  min-height: calc(3.275rem - 0.6rem);
}
.inbody-image-row.basis-info-row {
  border-bottom: none;
}
.inbody-result-row {
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
  font-size: 0.95rem;
  text-align: center;
}
.inbody-result-row.has-contents {
  padding-bottom: 1rem;
}
.intake-certificate-image-title .dot,
.begin-image-title .dot,
.result-image-title .dot,
.basis-info-row .dot {
  width: 0.5rem;
  height: 0.5rem;
  background: #360ea6;
  opacity: 0.2;
  border-radius: 50%;
  margin: 0 0.5rem;
}
.basis-info-label {
  font-weight: bold;
  display: flex;
  align-items: center;
  width: 7rem;
  font-size: 0.825rem;
}
.number-label {
  font-size: 0.8rem;
  color: #707070;
  line-height: 1.5rem;
}
.basis-info-number {
  float: right;
  margin-left: 0.2rem;
  color: black;
}
.basis-info-number >>> input.form-control {
  border: none;
  height: 1.4rem !important;
  padding: 0.1rem 0 0 !important;
  margin-bottom: 0.1rem !important;
}
.simple-design.basis-info-number {
  border: 1px solid #f4f4f4;
  border-radius: 0.766666666666667rem;
  height: 1.858333333333333rem;
  width: 100%;
}
.basis-info-number,
.basis-info-number >>> input {
  width: 3.65rem;
  height: auto;
  line-height: 1.5rem;
  border: none;
  font-size: 0.95rem;
  text-align: center;
}
.basis-info-result .simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.basis-info-goal .simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.simple-design.basis-info-number >>> .input-group,
.simple-design.basis-info-number >>> label {
  float: left;
  display: flex;
  align-items: center;
  height: 1.858333333333333rem;
  justify-content: center;
}
.simple-design.basis-info-number >>> label {
  font-size: 0.825rem;
  width: 3.691666666666667rem;
  background: #360ea6;
  color: white;
  border-radius: 0.766666666666667rem;
  margin-bottom: 0;
  margin: -1px;
}
.basis-info-begin,
.basis-info-goal,
.basis-info-result,
.basis-info-diff {
  width: 7.083333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.675rem;
}
.basis-info-goal {
  margin-bottom: 0.675rem;
}
.basis-info-diff {
  font-size: 0.95rem;
  margin-top: 0;
}
.basis-info-controls {
  width: 11rem;
  text-align: right;
}
div.basis-info-images-controls {
  width: 100%;
  text-align: unset;
}
.basis-info-controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.275rem;
  font-size: 0.66666666rem;
  width: 5.5rem;
  height: 1.483333rem;
  line-height: 0.1rem;
}
.show-sample {
  width: 4.5rem;
  height: 1.208rem;
  border-radius: 0.5rem;
  background: #ededed;
  color: #360ea6;
  font-size: 0.666666rem;
  text-align: center;
  margin-left: 1rem;
}
.basis-info-images-controls {
  display: block;
}
.basis-info-images-controls .basis-info-image {
  width: 50%;
  float: left;
}
.basis-info-images-controls >>> .dropping-line,
.basis-info-images-controls >>> .file-control,
.basis-info-images-controls >>> .file-preview-slide {
  height: 3.68333rem;
  width: 3.68333rem;
}
.basis-info-images-controls .basis-info-control {
  margin-left: 0.908rem;
  text-align: center;
}
.basis-info-images-controls .basis-info-control.basis-info-image {
  margin-left: 0;
  display: flex;
  justify-content: space-between;
}
.basis-info-control >>> .upload-guide {
  display: none;
}
.basis-info-control >>> .input-control {
  overflow: hidden;
  margin-bottom: 0;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.basis-info-control >>> .no-selected-file {
  background-size: cover;
  background-position: 0 0.6rem;
}
.basis-info {
  background: white;
  border-radius: 0.5rem;
  margin-bottom: 0.3rem;
  margin-top: 0.8rem;
}
.basis-info-diff {
  display: flex;
  align-items: center;
  justify-content: center;
}
.basis-info-diff i {
  font-size: 1.2rem;
  color: #bebebe;
}
.basis-info-diff i.fa-minus {
  font-size: 0.8rem;
}
.image-container {
  width: 7.358333333333333rem;
  height: 7.358333333333333rem;
  overflow: hidden;
  background-color: rgb(13, 71, 161, 0.1);
}
.image-container >>> .default-image {
  width: 1.833333333333333rem !important;
  height: 2.066666666666667rem !important;
  margin-top: calc(50% - 1.033333333333333rem) !important;
}
.basis-info-control-name-and-button {
  width: calc(100% - 7.358333333333333rem);
  height: 7.358333333333333rem;
}
.basis-info-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
.basis-info-image {
  width: 8rem;
}
.basis-info-label-image {
  width: calc(100% - 10rem);
}

.basis-info-control-name-and-button {
  padding: 0 0.816666666666667rem;
}

.basis-info-control-name-and-button .basis-info-control-name {
  font-size: 0.6666rem;
  color: #0a2e65;
}
.basis-info-control-name-and-button .upload-btn {
  background: #d8d8d8;
  border-radius: 0.566666666666667rem;
  color: white;
  font-size: 0.716666666666667rem;
  width: 3.233333333333333rem;
  height: 1.608333333333333rem;
  margin-top: 0.608333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.basis-info-overview {
  width: calc((100% - 0.1916rem) / 3);
  display: flex;
  align-items: center;
}
.result-image-container {
  width: calc(100% - 5.1916rem);
}
.result-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.result-image-wrapper-day {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.result-image-wrapper-day:last-child {
  border-bottom: none !important;
}
.result-image-container .image-datetime {
  width: 8rem;
  text-align: center;
}
.basis-info-result-photo-label {
  width: 5rem;
}
.basis-info-row.no-padding {
  padding: 0;
}
.basis-info-row.no-flex {
  display: block;
}
.result-image-wrapper {
  padding: 0.6rem 0;
}
.result-image-wrapper:last-child {
  border-bottom: none !important;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: center;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  font-size: 0.95rem;
  height: 2.358rem;
  margin: 0 0.3rem;
  width: 6.7333rem;
}
.plus.shared,
.minus.shared {
  color: gray;
}
.btn.btn-like {
  background: #28c8ea;
}
.reset-story-container {
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
  padding-bottom: 0.6rem;
}
.reset-story-box {
  border: 1px solid #aaaaaa;
  padding: 1rem;
  margin: 0 1rem;
  font-size: 0.95rem;
}
.schedule-time-tabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.schedule-time-tabs div {
  font-size: 0.95rem;
  font-weight: bold;
  padding: 1.2rem 1rem 0.5rem;
  opacity: 0.5;
  border-bottom: 1px solid white;
}
.schedule-time-tabs div.active {
  border-bottom: 1px solid #360ea6;
  opacity: 1;
}
.date-selector-detail {
  background: #360ea6;
  margin: 0.5rem;
  border-radius: 0.8rem;
  padding: 0.5rem 0;
  background-image: url(/img/unistars/background_bottom.png);
  background-repeat: no-repeat;
  background-size: 100vw;
  background-position-y: -5rem;
  background-attachment: scroll;
  color: white;
}
.product {
  display: flex;
  align-items: center;
  height: 4.6666rem;
  border-bottom: 1px solid #ececec;
  padding: 1rem;
}
.product-image img {
  width: 3.48333rem;
  margin: 0 1rem;
  background-color: rgb(13, 71, 161, 0.1);
}
.product .dot {
  width: 0.1916rem;
  height: 0.1916rem;
  background: #b2b2b2;
  border-radius: 0.1rem;
}
.product-title {
  font-size: 1rem;
  color: #2c2c2c;
  width: calc(100vw - 12.5rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-intake-co {
  font-size: 0.8333rem;
  display: flex;
  align-items: center;
  justify-content: end;
}
.product-intake-co input {
  border: 1px solid rgba(190, 190, 1990, 0.5);
  width: 2.79rem;
  text-align: center;
  font-size: 0.95rem;
}
.product-intake-co-unit {
  width: 2.5rem;
  padding-left: 0.5rem;
  font-size: 0.8833rem;
}
img.time-icon {
  height: 0.98333333rem;
}
.no-intake-data {
  text-align: center;
  padding: 3rem 0;
}
.show-agreement-button {
  float: left;
  margin-left: 1rem;
}
.agree-checkbox {
  float: left;
}
.schedule-intake-container {
  max-height: 14rem;
  overflow-y: scroll;
}
.basis-info-diff i.fa-caret-up {
  color: #cf0123;
}
.basis-info-diff i.fa-caret-down {
  color: #360ea6;
}
.basis-info-row.header-row .basis-info-label {
  width: calc(100% - 19.5rem);
}
.basis-info-2-container {
  display: flex;
  overflow: auto;
  width: 100vw;
  padding-bottom: 1rem;
}
.basis-info-2-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.basis-info-2-container .basis-info-row {
  width: calc(100vw / 3 - 1.1rem);
  min-width: calc(100vw / 3 - 1.1rem);
  margin-left: 0.65rem;
  margin-top: 0.775rem;
  display: flex;
  padding: 0 0.5rem;
  flex-direction: column;
  border: 1px solid #f4f4f4;
  border-radius: 0.208333333333333rem;
}
.basis-info-label-container {
  display: flex;
  align-items: center;
  height: 2.166666666666667rem;
  border-bottom: 1px solid #f4f4f4;
  width: 100%;
  font-size: 0.833333333333333rem;
}
.begin-image-row,
.result-image-row,
.intake-certificate-image-row {
  border: 1px solid rgba(153, 153, 153, 0.4);
  border-radius: 0.5rem;
  margin: 0.65rem;
  padding: 1rem;
}
.intake-certificate-image-row {
  padding-bottom: 0.15rem;
}
.intake-certificate-image-row .hist-info-image {
  margin-bottom: 0.85rem;
}
.begin-image-title,
.result-image-title,
.intake-certificate-image-title {
  display: flex;
  border-bottom: 1px solid rgba(153, 153, 153, 0.4);
  height: 1.541666666666667rem;
  align-items: center;
  padding-bottom: 0.541666666666667rem;
  margin-bottom: 1rem;
}
.begin-image-title .basis-info-label,
.result-image-title .basis-info-label,
.intake-certificate-image-title .basis-info-label {
  width: calc(100% - 1.5rem);
  display: block;
}
.begin-image-title .basis-info-label .show-sample,
.result-image-title .basis-info-label .show-sample {
  float: right;
}
</style>
